import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

const QueuesVuexModule = {
  namespaced: true,
  state: () => ({
    $_moduleApiPath: "v1.0/Dashboard",
    $_printApiPath: "v1.0/Print",
    $_paramApiPath: "v1.0/Audit",
    $_controlItems: [],
    $_controlData: [],
    $_currentPrintCondition: {},
    $_errorState: {},
    $_actionState: {
      message: "",
      status: 200,
      data: {}
    }
  }),
  getters: {
    controlItems: (state) => state.$_controlItems,
    currentControlData: (state) => state.$_controlData,
    actionState: (state) => state.$_actionState,
    errorState: (state) => state.$_errorState
  },
  actions: {
    setPrintCondition({ commit }, printConditions) {
      commit("SET_CONTROL_ITEMS", printConditions);
    },
    async getControlItems({ commit, dispatch, state, rootGetters }, filter) {
      var baseUrl = rootGetters.baseUrl;
      var actionLink = baseUrl + state.$_moduleApiPath + "/GetFilteredData";
      var axiosConfig = rootGetters.axiosConfig;
      try {
        //const response = await axios.get(actionLink, axiosConfig);
        const response = await axios.post(actionLink, filter, axiosConfig);
        commit("SET_CONTROL_ITEMS", response.data);
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    },
    async getDocumentPDF({ state, rootGetters }, printData) {
      var baseUrl = rootGetters.baseUrl;
      var actionLink =
        baseUrl + state.$_printApiPath + "/GetPolicyPdfByEndorsementId";
      var axiosConfig = rootGetters.axiosConfig;
      try {
        const response = await axios.post(actionLink, printData, axiosConfig);
        //const response = await axios.post(actionLink, printData);
        return response.data;
      } catch (error) {
        if (error.response != undefined) return error.response;
        else return error;
      }
    },

    async getEndorsementId({ dispatch, state, rootGetters }, data) {
      var baseUrl = rootGetters.baseUrl;
      var actionLink =
        baseUrl + state.$_moduleApiPath + "/GetPolicyEndorsementId";
      var axiosConfig = rootGetters.axiosConfig;
      try {
        //const response = await axios.get(actionLink, axiosConfig);
        const response = await axios.post(actionLink, data, axiosConfig);
        return response.data;
      } catch (error) {
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
        if (error.response != undefined) return error.response;
        else return error;
      }
    },
    async queueManualPrint({ dispatch, state, rootGetters }, data) {
      var baseUrl = rootGetters.baseUrl;
      var actionLink = baseUrl + state.$_moduleApiPath + "/QueueManualPrint";
      var axiosConfig = rootGetters.axiosConfig;
      try {
        //const response = await axios.get(actionLink, axiosConfig);
        const response = await axios.post(actionLink, data, axiosConfig);
        return response.data;
      } catch (error) {
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
        if (error.response != undefined) return error.response;
        else return error;
      }
    },
    async requeuePrint({ dispatch, state, rootGetters }, data) {
      var baseUrl = rootGetters.baseUrl;
      var actionLink = baseUrl + state.$_moduleApiPath + "/RequeuePrint";
      var axiosConfig = rootGetters.axiosConfig;
      try {
        //const response = await axios.get(actionLink, axiosConfig);
        const response = await axios.post(actionLink, data, axiosConfig);
        return response.data;
      } catch (error) {
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
        if (error.response != undefined) return error.response;
        else return error;
      }
    },    
    async sendPrintPreview({ dispatch, state, rootGetters }, preview) {
      var baseUrl = rootGetters.baseUrl;
      var actionLink = baseUrl + state.$_moduleApiPath + "/QueuePrintPreview";
      var axiosConfig = rootGetters.axiosConfig;
      try {
        //const response = await axios.get(actionLink, axiosConfig);
        const response = await axios.post(actionLink, preview, axiosConfig);
        return response.data;
      } catch (error) {
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
        if (error.response != undefined) return error.response;
        else return error;
      }
    },
    async getControlData({ state, rootGetters }, id) {
      var baseUrl = rootGetters.baseUrl;
      var actionLink =
        baseUrl + state.$_moduleApiPath + "/GetPrintControlDetail/" + id;
      var axiosConfig = rootGetters.axiosConfig;
      try {
        const response = await axios.get(actionLink, axiosConfig);
        //const response = await axios.post(actionLink, filter, axiosConfig);
        return response.data;
      } catch (error) {
        if (error.response != undefined) return error.response;
        else return error;
      }
    },
    async getControlIntegrations({ state, rootGetters }, query) {
      var baseUrl = rootGetters.baseUrl;
      var actionLink =
        baseUrl + state.$_moduleApiPath + "/GetPrintControlIntegrations";
      var axiosConfig = rootGetters.axiosConfig;
      try {
        const response = await axios.post(actionLink, query, axiosConfig);
        return response.data;
        //const response = await axios.get(actionLink, axiosConfig);
        //const response = await axios.post(actionLink, filter, axiosConfig);
      } catch (error) {
        if (error.response != undefined) return error.response;
        else return error;
      }
    }
  },
  mutations: {
    SET_CONTROL_ITEMS(state, value) {
      state.$_controlItems = value;
    },
    SET_CONTROL_DATA(state, value) {
      state.$_controlData = value;
    },
    SET_ERROR(state, value) {
      state.$_errorState = value;
    }
  }
};

export default QueuesVuexModule;
